import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './OrderSuccess.module.scss';
import { Button } from '@src/components/ui';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import ROUTE_PATHS from '../../routes/paths';
const OrderSuccess = () => {
    const navigate = useNavigate();
    const { user, isAuthenticated } = useAuth();
    // Get clinic account number if available
    const clinicAccountNumber = isAuthenticated && user?.defaultClinic?.accountNumber ? user.defaultClinic.accountNumber : null;
    return (_jsx("main", { className: styles.orderSuccess, children: _jsxs("section", { className: styles.orderSuccessWrapper, children: [_jsx("h1", { children: "Thank You for Your Order" }), _jsx("p", { children: "You\u2019ll receive an order confirmation with shipping details via email shortly." }), _jsx(Button, { variant: "primaryV2", size: "large", label: "Keep Shopping", className: styles.shoppingButton, onClick: () => navigate(ROUTE_PATHS.products) })] }) }));
};
export default OrderSuccess;
